class VideoControls extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback()
  }

  setupListeners() {
    super.setupListeners()

    this.handleSoundClick = this.handleSoundClick.bind(this)

    if (this.els?.sound?.exists === true) {
      this.listeners.add(this.els.sound.element, 'click', this.handleSoundClick)
    }
  }

  handleSoundClick(event) {
    const section = event.target.closest(this?.externalEls?.section?.selector)

    if (!section) return

    const allVideos = Array.from(section.querySelectorAll('video')).filter(
      (el) => el.readyState >= 2
    )

    const videos = allVideos.filter((el) => el.offsetParent !== null)

    // Mute any non-visible videos
    allVideos.filter((el) => el.offsetParent === null).forEach((el) => {
      el.muted = true
    })

    videos.forEach((el) => {
      const video = el
      if (video.muted === true) {
        video.muted = false
        this.updateSoundButton(false, section)
      } else {
        if (video.muted === false) {
          video.muted = true
          this.updateSoundButton(true, section)
        }
      }
    })
  }

  updateSoundButton(isMuted, section) {
    const buttons = section.querySelectorAll(this.els.sound.selector)

    buttons.forEach((button) => {
      button.setAttribute('aria-pressed', isMuted ? 'false' : 'true')

      const playText = this.querySelector(this.els['sound-text'].selector)
      playText.textContent = isMuted ? this.dataset.unmute : this.dataset.mute
    })
  }
}

if (!customElements.get('video-controls')) {
  customElements.define('video-controls', VideoControls)
}